export enum EstatusHUCUenum {
    PENDIENTE = 'PENDIENTE',
    EN_PROCESO = 'EN_PROCESO',
    COMPLETADA = 'COMPLETADA',
    EN_QA = 'EN_QA',
    VOBO = 'VOBO',
    LIBERADA = 'LIBERADA',
    INICIO = 'INICIO',
    ASIGNADO ="ASIGNADO",
    FINALIZADO = 'FINALIZADO'
}

export class EstatusHUCUTASK {
    public static obtenerEnum(valor: string): EstatusHUCUenum {
        switch (valor) {
            case 'PENDIENTE': return EstatusHUCUenum.PENDIENTE;
            case 'EN PROCESO': return EstatusHUCUenum.EN_PROCESO;
            case 'COMPLETADA': return EstatusHUCUenum.COMPLETADA;
            case 'EN QA': return EstatusHUCUenum.EN_QA;
            case 'VOBO': return EstatusHUCUenum.VOBO;
            case 'LIBERADA': return EstatusHUCUenum.LIBERADA;
            case 'INICIO': return EstatusHUCUenum.INICIO;
            case 'ASIGNADO': return EstatusHUCUenum.ASIGNADO;
            case 'FINALIZADO': return EstatusHUCUenum.FINALIZADO
            
        }
        return null;
    }

    public static eliminarGuion(estatus: string){
        return estatus.replace('_',' ')
    }
}